// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

const baseRoute: string = 'https://test-customer-app-server.leada.de';

export const environment = {
  name: 'acceptance',
  production: false,
  voucher: `${baseRoute}/vouchers`,
  registration: `${baseRoute}/registration`,
  event_registration: `${baseRoute}/event_registration`,
  email_confirmation: `${baseRoute}/email_confirmation`,
  download: 'http://www.leada.de',
};
